import React from 'react';
import { FaWhatsapp, FaPhone, FaFacebookF, FaInstagram, FaEnvelope, FaMapMarkerAlt, FaHeart } from 'react-icons/fa';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.topSection}>
          <div className={styles.brand}>
            <h3 className={styles.brandName}>Janki's Cloud Kitchen</h3>
            <p className={styles.tagline}>Pure, Fresh & Truly Homemade</p>
          </div>

          <div className={styles.contactInfo}>
            <div className={styles.contactItem}>
              <FaEnvelope className={styles.contactIcon} />
              <a href="mailto:taste@jankiscloudkitchen.in">taste@jankiscloudkitchen.in</a>
            </div>
            <div className={styles.contactItem}>
              <FaPhone className={styles.contactIcon} />
              <div className={styles.phoneNumbers}>
                {/* <a href="tel:+919601399999">+91 96013 99999</a>
                <span className={styles.separator}>|</span> */}
                <a href="tel:+918183934567">+91 81839 34567</a>
              </div>
            </div>
            <div className={styles.contactItem}>
              <FaMapMarkerAlt className={styles.contactIcon} />
              <span>Rajkot, Gujarat</span>
            </div>
          </div>

          <div className={styles.social}>
            <a href="https://wa.me/918183934567" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href="tel:+918183934567" className={styles.socialIcon} aria-label="Call">
              <FaPhone />
            </a>
            <a href="https://www.facebook.com/share/17akp7KCqh/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/jankiscloudkitchen?igsh=MWNibGUxeHU2ZnlhbQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className={styles.bottomSection}>
          <div className={styles.copyright}>
            <p>© 2025 Janki's Cloud Kitchen. All rights reserved.</p>
            <p className={styles.madeWith}>
              Made with <FaHeart className={styles.heartIcon} /> in Rajkot
            </p>
          </div>
          <div className={styles.developer}>
            <p>Developed by <a href="https://triklabs.com" target="_blank" rel="noopener noreferrer" className={styles.trikLabs}>TrikLabs</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
